import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { MaterialBody, MaterialDetails, MaterialListItem } from "types/api/material";

function useMaterialApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllMaterial = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<MaterialListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<MaterialListItem>>({
            url: "/material",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneMaterial = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<MaterialDetails> => {
        return get<PathParamsWithId, undefined, MaterialDetails>({
            url: "/material/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createMaterial = React.useCallback((body: MaterialBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, MaterialBody, ResponseWithId>({
            url: "/material",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateMaterial = React.useCallback((pathParams: PathParamsWithId, body: MaterialBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, MaterialBody, null>({
            url: "/material/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteMaterial = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/material/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllMaterial,
        getOneMaterial,
        createMaterial,
        updateMaterial,
        deleteMaterial
    };
}

export default useMaterialApi;